module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUoAAADPAgMAAADuTXBJAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAADFBMVEXbFDz////gMVTcFDzCLUbRAAAAAXRSTlNANjqZ9gAAAAFiS0dEAf8CLd4AAAAHdElNRQfpAgMDLypeC1OGAAAAZElEQVR42u3MsRUAEBAFsD+ixn5q09mAHbxTSQZIerkWp9PpdDqdTqfT6XQ6nU6n0+l0Op1Op9PpdDqdTufdOcuN7HLL6XQ6nU6n0+l0Op1Op9PpdDqdTqfT6XQ6nU6n84vzgQOZUzkjJfBYWAAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyNS0wMi0wM1QwMzo0Nzo0MiswMDowMOZzONcAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjUtMDItMDNUMDM6NDc6NDIrMDA6MDCXLoBrAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/lang/bl.png
// module id = z0/1
// module chunks = 128